<template>
  <main role="main">

    <section class="jumbotron text-center" style="width: 100%; display: flex; justify-content: center;">
      <div class="container" id="app">
        <div class="search-container">
          <div class="search-box">
            <input type="text" v-model="words" id="inp" @keydown.enter="search" @input="handleInput"/>
            <button @click="search">搜索一下</button>
          </div>
          <div>
            <ul v-if="suggestions.length > 0" class="suggestions-list">
              <li
                  v-for="(suggestion, index) in suggestions"
                  :key="index"
                  @click="selectSuggestion(suggestion)">
                {{ suggestion }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <div class="album py-5 bg-light">
      <div class="container">
        <div class="title2">课程列表</div>
        <div class="row">
          <div v-for="o in news" class="col-md-4">
            <the-course v-bind:course="o"></the-course>
          </div>
        </div>

      </div>
    </div>

  </main>
</template>

<script>

import TheCourse from "../components/the-course";

export default {
  name: 'index',
  components: {TheCourse},
  data: function () {
    return {
      news: [],
      words: '',
      suggestions: [],
      suggestionsTips: [],
      queryParams: {}, // 用于存储查询参数的对象
    }
  },
  mounted() {
    document.querySelector('#inp').focus();
  },

  created() {
    let _this = this;
    _this.searchSuggestion();
    _this.listNew();
  },
  methods: {

    listNew() {
      let _this = this;

      let news = SessionStorage.get("search_news");
      if (!Tool.isEmpty(news)) {
        _this.news = news;
        return;
      }


      // 新上好课不经常变，又经常被访问，适合用缓存
      // 判断是否有缓存

      _this.$ajax.get(process.env.VUE_APP_SERVER + '/business/web/course/list-new').then((response) => {
        console.log("查询新上好课结果：", response);
        let resp = response.data;
        if (resp.success) {
          _this.news = resp.content;
          // 保存到缓存
          SessionStorage.set("search_news", _this.news);
        }
      }).catch((response) => {
        console.log("error：", response);
      })
    },


    selectSuggestion(suggestion) {
      this.words = suggestion; // 将选中的建议赋值给input框的v-model绑定值
      this.search(); // 可以选择是否立即执行搜索操作
    },

    search(event) {
      let _this = this;
      //后端参数名称为"status"
      _this.queryParams.status = this.words;
      console.log(_this.queryParams.status, "1111111")
      _this.$ajax.post(process.env.VUE_APP_SERVER + '/business/web/course/search', _this.queryParams).then((response) => {
        console.log("查询结果：", response);
        let resp = response.data;
        if (resp.success) {
          _this.news = resp.content;
        }
      }).catch((response) => {
        console.log("error：", response);
      })
    },


    searchSuggestion() {
      let _this = this;
      _this.$ajax.get(process.env.VUE_APP_SERVER + '/business/web/course/getSearchSuggestion').then((response) => {
        console.log("查询结果：", response);
        let resp = response.data;
        if (resp.success) {
          _this.suggestionsTips = resp.content;
        }
      }).catch((response) => {
        console.log("error：", response);
      })
    },

    handleInput(event) {
      // 清空旧的搜索建议
      this.suggestions = [];

      // 获取用户当前输入的内容
      const query = event.target.value;

      // 这里以一个模拟的数据源为例，实际应用中可能是从服务器API获取数据
      const dataSource = this.suggestionsTips;

      // 根据输入内容筛选建议
      if (query) {
        this.suggestions = dataSource.filter(item => item.includes(query));
      }
    }
  }
}
</script>

<style scoped>
.title1 {
  margin-bottom: 2rem;
  color: #fafafa;
  letter-spacing: 0;
  text-shadow: 0px 1px 0px #999, 0px 2px 0px #888, 0px 3px 0px #777, 0px 4px 0px #666, 0px 5px 0px #555, 0px 6px 0px #444, 0px 7px 0px #333, 0px 8px 7px #001135;
  font-size: 2rem;
}

.title2 {
  margin-bottom: 2rem;
  color: transparent;
  -webkit-text-stroke: 1px black;
  letter-spacing: 0.04em;
  font-size: 2rem;
}
.suggestions-list {
  list-style-type: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.search-container {
  width: 100%; /* 容器宽度占满父容器 */
  max-width: 800px; /* 最大宽度限制 */
  margin: 0 auto; /* 居中对齐 */
  text-align: center;
}

.search-container .search-box {
  display: flex;
  width: 100%; /* 搜索框宽度占满父容器 */
}

.search-container img {
  margin-bottom: 30px;
}

.search-container .search-box input {
  flex: 1; /* 输入框占据剩余空间 */
  padding: 12px 16px;
  font-size: 16px;
  margin: 0;
  vertical-align: top;
  outline: 0;
  box-shadow: none;
  border-radius: 10px 0 0 10px;
  border: 2px solid #c4c7ce;
  background: #fff;
  color: #222;
  overflow: hidden;
  box-sizing: border-box; /* 使用 border-box 以包含 padding 和 border 在内 */
  -webkit-tap-highlight-color: transparent;
}

.search-container .search-box button {
  cursor: pointer;
  width: 20%; /* 按钮宽度占父容器的20% */
  min-width: 112px; /* 最小宽度限制 */
  line-height: 42px;
  background-color: #ad2a27;
  border-radius: 0 10px 10px 0;
  font-size: 17px;
  box-shadow: none;
  font-weight: 400;
  border: 0;
  outline: 0;
  letter-spacing: normal;
  color: white;
}

body {
  background: no-repeat center /cover;
  background-color: #edf0f5;
}

</style>
